import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { makeStyles } from '@material-ui/core';

HighchartsMore(Highcharts);

const useStyles = makeStyles(() => ({
  labelNumber: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: '#000000',
  },
  labelText: {
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: '#000000',
  },
}));

const FunnelChart = ({ data = [], chartLabels = [] }) => {
  const classes = useStyles();
  const labels = chartLabels.map(
    ({ count, value }) =>
      `<b class="${classes.labelNumber}">${count}</b><br /><span class="${classes.labelText}">${value}</span>`
  );

  const options = {
    credits: {
      enabled: false,
    },
    chart: {
      type: 'polygon',
    },
    title: {
      text: '',
    },
    colors: ['#4b8c6f', '#6fa38c', '#d7e5df', '#d7e5df'],
    xAxis: {
      tickLength: 0,
      tickAmount: 5,
      lineWidth: 0,
      gridLineWidth: 1,
      min: 0,
      max: 40,
      labels: {
        formatter: (point) => {
          const index = point.value / 10 - 1;

          if (index < 0) {
            return '';
          }

          return labels[index];
        },
        y: -350,
        x: -140,
        align: 'left',
        enabled: true,
      },
    },

    yAxis: {
      max: 60,
      gridLineWidth: 0,
      title: {
        text: '',
      },
      labels: {
        enabled: false,
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      polygon: {
        enableMouseTracking: false,
      },
    },
    series: data,
  };

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        immutable={true}
      />
    </div>
  );
};

export default FunnelChart;
